import { Airlines, Ports, Providers, BookingDateOrFlightDate } from './../interfaces/accounting-report.interface';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {
    AccountingReportFilter,
    IAccountingMonthlyReport,
    IAccountingSummaryUnit,
    IReservationAccountingResponse
} from '../interfaces/accounting-report.interface';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AccountingReportService {
    http = inject(HttpClient);
    baseUrl = environment.apiUrl;
    constructor() {}

    getReservationDetails(filter: Partial<AccountingReportFilter>): Observable<IReservationAccountingResponse> {
        const apiUrl = `${this.baseUrl}/accounting-report/reservations`;
        let params = new HttpParams();
        Object.keys(filter).forEach((key) => {
            const value = filter[key as keyof AccountingReportFilter];
            if (value !== undefined && value !== null && value !== '') {
                params = params.set(key, value as any);
            }
        });
        return this.http.get<IReservationAccountingResponse>(apiUrl, { params });
    }

    getAccountingSummary(accountingFilter: Partial<AccountingReportFilter>): Observable<IAccountingSummaryUnit[]> {
        const apiUrl = `${this.baseUrl}/accounting-report/summary`;
        let params = new HttpParams();
        Object.keys(accountingFilter).forEach((key) => {
            const value = accountingFilter[key as keyof AccountingReportFilter];
            if (value !== undefined && value !== null && value !== '') {
                params = params.set(key, value as any);
            }
        });
        return this.http.get<IAccountingSummaryUnit[]>(apiUrl, { params: accountingFilter as any });
    }

    getAccountingMonthlyReport(year: number, dateBasis: BookingDateOrFlightDate | null): Observable<IAccountingMonthlyReport> {
        const apiUrl = `${this.baseUrl}/accounting-report/monthly`;
        let params = new HttpParams().set('year', year.toString());
        if (dateBasis !== null) {
            params = params.set('dateType', dateBasis);
        }
        return this.http.get<IAccountingMonthlyReport>(apiUrl, { params });
    }
    getAccountingMonthlyReportComparison(year: number[], dateBasis: BookingDateOrFlightDate | null): Observable<IAccountingMonthlyReport> {
        const apiUrl = `${this.baseUrl}/accounting-report/monthly/comparison`;
        let params = new HttpParams().set('year1', year[0].toString());
        params = params.set('year2', year[1].toString());
        if (dateBasis !== null) {
            params = params.set('dateType', dateBasis);
        }
        return this.http.get<IAccountingMonthlyReport>(apiUrl, { params });
    }
    getAccountingReservationDetails(filter: Partial<AccountingReportFilter>): Observable<IReservationAccountingResponse> {
        const apiUrl = `${this.baseUrl}/accounting-report/reservations`;
        let params = new HttpParams();
        Object.keys(filter).forEach((key) => {
            const value = filter[key as keyof AccountingReportFilter];
            if (value !== undefined && value !== null && value !== '') {
                params = params.set(key, value as any);
            }
        });

        return this.http.get<IReservationAccountingResponse>(apiUrl, { params });
    }
    getTripCount(filter: Partial<AccountingReportFilter>): Observable<any> {
        const apiUrl = `${this.baseUrl}/accounting-report/trip-counts`;
        let params = new HttpParams();

        Object.keys(filter).forEach((key) => {
            const value = filter[key as keyof AccountingReportFilter];
            if (value !== undefined && value !== null && value !== '') {
                params = params.set(key, value as any);
            }
        });

        return this.http.get<any>(apiUrl, { params });
    }
    getAirlines(): Observable<Airlines[]> {
        const apiUrl = `${this.baseUrl}/airlines`;
        return this.http.get<Airlines[]>(apiUrl);
    }
    getProviders(): Observable<Providers[]> {
        const apiUrl = `${this.baseUrl}/providers`;
        return this.http.get<Providers[]>(apiUrl);
    }
    getPorts(): Observable<Ports[]> {
        const apiUrl = `${this.baseUrl}/ports`;
        return this.http.get<Ports[]>(apiUrl);
    }
}
